export const MATERIAL_APPLICATION_CODE = 'ApplicationUse_DICT_SEL';
